var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-view",attrs:{"align":"center"}},[(_vm.step == '1')?_c('add1',{attrs:{"templates":_vm.templates}}):_vm._e(),(_vm.step == '2')?_c('add2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }